'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'bolt';
var width = 384;
var height = 512;
var aliases = [9889,"flash"];
var unicode = 'f0e7';
var svgPathData = 'M381.1 244.8c-4.687-12.48-16.62-20.75-29.97-20.75l-124.2-.0114l88.84-177.7c6.843-13.69 3.031-30.28-9.062-39.64C301.8 2.209 294.9 0 287.1 0c-7.541 0-15.06 2.666-21.05 7.926L10.95 231.9c-10.03 8.782-13.59 22.86-8.906 35.33C6.728 279.7 18.66 288 32.01 288l124.2-.0089l-88.84 177.7c-6.843 13.69-3.031 30.28 9.062 39.64C82.22 509.8 89.13 512 96 512c7.531 0 15.06-2.656 21.06-7.922l255.1-223.1C383.1 271.3 386.6 257.2 381.1 244.8zM96 479.1l88.84-177.7c4.961-9.92 4.429-21.7-1.4-31.14c-5.83-9.434-16.13-15.18-27.22-15.18L32.02 255.1l255.1-223.1c.0039-.002-.0176 0 0 0c0 0-.002 0 0 0l-88.82 177.7c-4.961 9.918-4.429 21.7 1.4 31.13c5.83 9.436 16.13 15.18 27.22 15.18l124.2-.0059L96 479.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBolt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faBolt.js
// module id = f5kY
// module chunks = 0